import classNames from "classnames";
import dayjs from "dayjs";

import { roundAndDropTrailingZeros } from "@ascendnow/shared";
import { AscRankItemPropsI } from "./AscRankItem.type";
import styles from "./AscRankItem.module.scss";
import {
  RankListPodiumDecorationRectangle,
  RankFirstPlaceDecoration,
} from "../AscIllustrations";
import AscAvatar from "../AscAvatar/AscAvatar";
import AscTag from "../AscTag/AscTag";
import {
  CalendarEmptyIcon,
  JournalIcon,
  SchoolRepresentativeIcon,
} from "../AscIcons";
import AscRankSign from "../AscRankSign/AscRankSign";

function AscRankItem({
  type,
  size,
  pitchUrl,
  points,
  rank,
  avatarUrl,
  flag,
  name,
  birthDate,
  school,
  eventName,
  loading,
}: AscRankItemPropsI) {
  // const getRankTag = (rank: number) => {
  //   switch (rank) {
  //     case 1:
  //       return <AscTag type={"gold"} label={"Gold"} size={"small"} />;
  //     case 2:
  //       return <AscTag type={"silver"} label={"Silver"} size={"small"} />;
  //     case 3:
  //       return <AscTag type={"bronze"} label={"Bronze"} size={"small"} />;
  //     default:
  //       return null;
  //   }
  // };

  const getPointsTag = (points: number, rank: number) => {
    const pointsSuffix =
      points != null && Math.floor(points) !== 1 ? " points" : " point";

    const label = (
      <span className={styles.pointsLabel}>
        {points} <span className={styles.pointsSuffix}>{pointsSuffix}</span>
      </span>
    );
    switch (rank) {
      case 1:
        return (
          <AscTag
            className={styles.pointsTag}
            type={"points-first-place"}
            label={label}
          />
        );
      case 2:
        return (
          <AscTag
            className={styles.pointsTag}
            type={"points-second-place"}
            label={label}
          />
        );
      case 3:
        return (
          <AscTag
            className={styles.pointsTag}
            type={"points-third-place"}
            label={label}
          />
        );
      default:
        return (
          <AscTag className={styles.pointsTag} type={"points"} label={label} />
        );
    }
  };

  return (
    <div
      className={classNames(styles.element, styles[type], styles[size], {
        [styles.first]: rank === 1,
        [styles.second]: rank === 2,
        [styles.third]: rank === 3,
        [styles.loading]: loading,
      })}
    >
      <div className={styles.elementWrapper}>
        <div className={styles.leftColumn}>
          <div className={styles.rank}>
            <AscRankSign rank={rank} size={size} />
            {rank === 1 && size === "large" && (
              <RankFirstPlaceDecoration
                className={styles.firstPlaceDecoration}
                data-testid={"test-decor-first"}
              />
            )}
          </div>

          <div className={styles.avatarWrapper}>
            <AscAvatar
              className={styles.avatar}
              flagClassName={styles.avatarFlag}
              src={avatarUrl}
              alt={"avatar"}
              flag={flag}
              data-testid={"test-avatar"}
            />
          </div>
        </div>

        <div className={styles.rightColumn}>
          <div className={styles.textWrapper}>
            <div className={styles.nameWrapper}>
              <div className={styles.name}>{name}</div>
              {/* {rank && getRankTag(rank)} */}
            </div>
            <div className={styles.details}>
              {birthDate ? (
                <div className={styles.age}>
                  Age {Math.floor(dayjs().diff(dayjs(birthDate), "year"))}
                </div>
              ) : null}
              <div className={styles.school}>
                <SchoolRepresentativeIcon className={styles.schoolIcon} />
                {school}
              </div>
              {eventName && size === "large" && (
                <div className={styles.eventName}>
                  <CalendarEmptyIcon className={styles.eventIcon} />
                  {eventName}
                </div>
              )}
            </div>
          </div>
          {type === "with-pitch" && (
            <a
              className={styles.pitchUrl}
              href={pitchUrl}
              data-testid={"test-pitchUrl"}
            >
              <JournalIcon className={styles.pitchIcon} />
              Pitch
            </a>
          )}
          {type === "with-points" &&
            points != null &&
            getPointsTag(roundAndDropTrailingZeros(Number(points)), rank)}
        </div>
      </div>
      {(rank === 1 || rank === 2 || rank === 3) && size === "large" && (
        <RankListPodiumDecorationRectangle
          className={styles.decorationRectangle}
          data-testid={"test-decor"}
        />
      )}
    </div>
  );
}

export default AscRankItem;
